export const defaultBorderedClass = 'bordered'

export const defaultInputclass = 'defaultInput';

export const backgroundColor = 'var(--backgroundColor)'
export const baseColor = 'var(--baseElementColor)'
export const scndColor = 'var(--2cndElementColor)'
export const contrastColor = 'var(--contrastElementColor)'

export const errorColor = 'var(--errorColor)'

export const paddingWidth = 'var(--bordered-width)'
export const paddingHeight = 'var(--bordered-height)'

export const backUrl = '/api/v1'
// export const backUrl = 'api' 

//Если у тебя какая то функция, в которой нужен html код - вохмонжо стоит создать либо сервис, либо что ниюудь подобное

export function FormatDate(date) {
    const formattedDate = new Date(date).toLocaleDateString('ru-RU', {
        day: 'numeric',
        month: 'long',
        hour: '2-digit',
        minute: '2-digit'
    });

    return formattedDate;
}

export function FormatExperience(experience) {
    const currentYear = new Date().getFullYear();
    const formattedExperience = currentYear - experience;
    return formattedExperience;
}

export function isUserLogin(login) {
    return login === 'user';
}

export function classNames(...args) {
    const classes = [];

    args.forEach((arg) => {
        if (!arg) return; // Пропускаем falsy значения (null, undefined, false, 0, '')

        // Если аргумент — строка или число, добавляем его в массив
        if (typeof arg === 'string' || typeof arg === 'number') {
            classes.push(arg);
        }

        // Если аргумент — объект, добавляем ключи, значения которых true
        else if (typeof arg === 'object') {
            if (Array.isArray(arg)) {
                // Если это массив, рекурсивно вызываем classNames для его элементов
                classes.push(classNames(...arg));
            } else {
                // Если это объект, добавляем ключи, значения которых true
                for (const key in arg) {
                    if (arg.hasOwnProperty(key) && arg[key]) {
                        classes.push(key);
                    }
                }
            }
        }
    });

    // Объединяем все классы в одну строку
    return classes.join(' ');
}


function getTrueKeys(obj) {
    return Object.entries(obj)
      .filter(([_, value]) => value === true)
      .map(([key]) => key);
  }